import get from 'lodash/get';

export const userCanReadUIView = (uiView, userUIViews) =>
  get(userUIViews, [uiView, 'read'], false);
export const userCanCreateUIView = (uiView, userUIViews) =>
  get(userUIViews, [uiView, 'create'], false);
